import React from 'react';
import Loader from 'components/general/Loader';

export default function ModalLoader () {
	return (
		<div className="modal modal-message">
			<Loader />
		</div>
	)
}